import React, {
    ReactElement,
} from "react";
import Select from "../../../../components/select/Select";

const SERIALIZATION_TYPES = [

    {
        label: "JSON",
        value: "JSON",
    },
    {
        label: "URL",
        value: "URL",
    },
];

export default function SerializationSelect({
    value,
    onChange,
}: {
    value: string | undefined;
    onChange: (value: string | undefined) => void;

}): ReactElement {
    return (
        <Select
            className="mb-2"
            isClearable
            onChange={selected => onChange(selected?.value)}
            value={SERIALIZATION_TYPES.find(type => type.value === value)}
            options={SERIALIZATION_TYPES}
        />
    );
}
